import { ref } from 'vue'
import type { ComponentPublicInstance } from 'vue'

export interface DialogOptions {
  title: string
  message: string
  confirmText?: string
  cancelText?: string
  type: 'alert' | 'confirm'
}

// Singleton pattern
const dialogRef = ref<ComponentPublicInstance<{
  openDialog: (options: DialogOptions) => Promise<boolean>
}> | null>(null)

export function useDialog() {
  const alert = (title: string, message: string, confirmText: string | undefined = undefined): Promise<void> => {
    if (!dialogRef.value) {
      console.warn('Dialog component not mounted. Make sure AppDialog is in your root component.')
      return Promise.resolve()
    }
    return dialogRef.value.openDialog({
      title,
      message,
      confirmText,
      type: 'alert'
    }).then(() => {})
  }

  const confirm = (title: string, message: string, confirmText: string | undefined = undefined, cancelText: string | undefined = undefined): Promise<boolean> => {
    if (!dialogRef.value) {
      console.warn('Dialog component not mounted. Make sure AppDialog is in your root component.')
      return Promise.resolve(false)
    }
    return dialogRef.value.openDialog({
      title,
      message,
      confirmText,
      cancelText,
      type: 'confirm'
    })
  }

  return {
    dialogRef,
    alert,
    confirm
  }
}
